import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'auth/Portal/Home', component: Home, meta: { requiresAuth: true } },
  { path: '/Career', name: 'auth/Career', props : true, component: () => import('../views/Recruit/Career.vue'), meta: { requiresAuth: true } },
  { path: '/MemberInterview', name: 'auth/MemberInterview', component: () => import('../views/Recruit/MemberInterview.vue'), meta: { requiresAuth: true } },
  { path: '/MemberInterview1', name: 'auth/MemberInterview1', component: () => import('../views/Recruit/MemberInterview1.vue'), meta: { requiresAuth: true } },
  { path: '/MemberInterview2', name: 'auth/MemberInterview2', component: () => import('../views/Recruit/MemberInterview2.vue'), meta: { requiresAuth: true } },
  { path: '/MemberInterview3', name: 'auth/MemberInterview3', component: () => import('../views/Recruit/MemberInterview3.vue'), meta: { requiresAuth: true } },
  { path: '/MemberInterview4', name: 'auth/MemberInterview4', component: () => import('../views/Recruit/MemberInterview4.vue'), meta: { requiresAuth: true } },
  { path: '/MemberInterview5', name: 'auth/MemberInterview5', component: () => import('../views/Recruit/MemberInterview5.vue'), meta: { requiresAuth: true } },
  { path: '/Welfare', name: 'auth/Welfare', component: () => import('../views/Recruit/Welfare.vue'), meta: { requiresAuth: true } },
  { path: '/ApplicationType', name: 'auth/ApplicationType', component: () => import('../views/Recruit/ApplicationType.vue'), meta: { requiresAuth: true } },
  { path: '/ApplicationRecuirmentsEngineer', name: 'auth/ApplicationRecuirmentsEngineer', component: () => import('../views/Recruit/ApplicationRecuirmentsEngineer.vue'), meta: { requiresAuth: true } },
  { path: '/ApplicationRecuirmentsSales', name: 'auth/ApplicationRecuirmentsSales', props : true , component: () => import('../views/Recruit/ApplicationRecuirmentsSales.vue'), meta: { requiresAuth: true } },
  { path: '/ApplicationForm', name: 'auth/ApplicationForm', component: () => import('../views/Recruit/ApplicationForm.vue'), meta: { requiresAuth: true } },
  { path: '/Infographics', name: 'auth/Infographics', component: () => import('../views/Recruit/Infographics.vue'), meta: { requiresAuth: true } },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
        return savePosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 50 }
      }
    }
    return { x: 0, y: 0 };
}
  
})

export default router
